module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/glyphicons-halflings-regular.woff
// module id = ./node_modules/@ps/common-core/dist/fonts/glyphicons-halflings-regular.woff
// module chunks = 1